import React from "react";
import styled from "@emotion/styled";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import ArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

import styleConfig from "styles/styleConfig";

const { colors, padding, fontSize, borderRadius, boxShadow, transition } = styleConfig;

interface Props extends React.PropsWithChildren {
  position: number;
  total: number;
  handleClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void | undefined;
}

const width = "100%";
const height = "300px";

const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: ${width};
`;
const Children = styled.div`
  width: ${width};
  position: relative;
  height: ${height};
`;
const Arrow = styled.div<{ right?: boolean }>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  height: 30px;
  margin: auto 0;
  color: ${colors.gray[100]};
  background-color: ${colors.gray[600]};
  z-index: 90;
  text-align: center;
  width: 30px;
  font-size: 3em;
  border-radius: ${borderRadius.xl};
  opacity: 0.3;
  ${props => (props.right ? "right:" + padding[4] : "left:" + padding[4])};
  cursor: pointer;
  user-select: none;
  transition: ${transition.default};
  &:hover {
    opacity: 0.7;
    box-shadow: ${boxShadow.default};
  }
`;
const Dot = styled.span`
  margin: 0 2px;
  font-size: ${fontSize.sm};
  text-shadow: ${boxShadow.md};
  user-select: none;
  cursor: pointer;
`;
const Dots = styled.span`
  position: absolute;
  text-align: center;
  width: ${width};
  color: ${colors.gray[400]};
  z-index: 90;
  bottom: 0;
`;
const CarouselUI: React.FC<Props> = ({ position, total, handleClick, children }) => (
  <Container>
    <Children>
      {children}
      <Arrow onClick={handleClick} data-position={position - 1}>
        <ArrowLeftIcon />
      </Arrow>
      <Arrow onClick={handleClick} data-position={position + 1} right>
        <ArrowRightIcon />
      </Arrow>
    </Children>
    <Dots>
      {Array(...Array(total)).map((_, index) => (
        <Dot key={index} onClick={handleClick} data-position={index}>
          {index === position ? "●" : "○"}
        </Dot>
      ))}
    </Dots>
  </Container>
);

export default CarouselUI;
